// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_eV","advertDetailService__price":"c-o_eW"};